module.exports = __webpack_public_path__ + "static/media/luft-logo.31982cfb.svg";